import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import AdminLinks from './AdminLinks';
import { NAV_ITEMS } from '../Layout';
import '../Layout.css';

export default function MobileMenu({ mobileMenuOpen, setMobileMenuOpen }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  if (!mobileMenuOpen) return null;

  return (
    <div className="mobile-menu">
      {NAV_ITEMS.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`mobile-nav-link nav-link ${location.pathname === item.path ? 'active' : ''}`}
          onClick={() => handleNavClick(item.path)}
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
}
